import * as React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Modal from '@mui/material/Modal'
import UploadDocIcon from '../assets/imgs/upload-documents-icon.svg'
import WorkLicenseModal from './WorkLicenseModal'
import CreateServiceModal from './CreateServiceModal'
import { TextField } from '@mui/material'
import { saveOrUpdateDataById } from '../apis/generalApis'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  outline: 'none',
  bgcolor: 'background.paper',
  border: '2px solid #fff',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  borderRadius: '16px',
  textAlign: 'center',
}

const IdentityProofDocumentsModal = ({
  handleIdentityProofDocumentsModal,
  modalOpen = false,
  component = '',
}) => {
  const user = JSON.parse(localStorage.getItem('user'))
  const [toggleWorkLicenseModal, setToggleWorkLicenseModal] = React.useState(
    false,
  )
  const [createServiceModal, setCreateServiceModal] = React.useState(false)
  const [isLoading, setIsLoading] = React.useState(false)
  const handleWorkLicenseModal = () => {
    if (modalOpen) {
      handleIdentityProofDocumentsModal(false)
    }
    if (component === 'sign-up') {
      handleCreateServiceModal()
    } else {
      setToggleWorkLicenseModal(!toggleWorkLicenseModal)
    }
  }

  const handleCreateServiceModal = () => {
    setCreateServiceModal((prev) => !prev)
  }

  const handleFileUpload = async (e) => {
    if (!e.target.files[0]) return
    setIsLoading(true)
    let formData = new FormData()
    formData.append('user_id', user?.id)
    formData.append('file', e.target.files[0])
    let result = await saveOrUpdateDataById('upload-identity', formData)
    if (result?.success === true) {
      setIsLoading((prev) => !prev)
    }
  }

  return (
    <div>
      <Modal
        open={modalOpen}
        onClose={() => handleIdentityProofDocumentsModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="modal-width">
          <div className="row">
            <div className="col-12">
              <h3 className="fs-24 mb-3 fw-bold">Identity Proof Documents</h3>
              <label
                className="upload-documents-wrapper py-5 w-100 pointer"
                htmlFor="identity-proof-doc"
                style={{ pointerEvents: isLoading === true ? 'none' : 'auto' }}
              >
                <img src={UploadDocIcon} alt="" className="mb-3" />
                <p className="fs-15 font-weight-bold color-primary">
                  Upload Documents
                </p>
                <TextField
                  type="file"
                  name="identity-proof-doc"
                  onChange={handleFileUpload}
                  id="identity-proof-doc"
                  style={{ display: 'none' }}
                />
              </label>
              <Button
                disableElevation
                id="btn-primary-no-shadow"
                variant="contained"
                onClick={handleWorkLicenseModal}
                className="pointer mt-5"
                fullWidth={true}
                disabled={isLoading === true}
              >
                {isLoading === true ? 'Uploading...' : 'Next'}
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
      {/* {toggleWorkLicenseModal && ( */}
      <WorkLicenseModal
        handleWorkLicenseModal={handleWorkLicenseModal}
        modalOpen={toggleWorkLicenseModal}
      />
      <CreateServiceModal
        handleCreateServiceModal={handleCreateServiceModal}
        createServiceModal={createServiceModal}
        component="sign-up"
        isNewService={true}
      />
      {/* )} */}
    </div>
  )
}

export default IdentityProofDocumentsModal
